var Reverb = window.Reverb || {};
Reverb.BundledCheckout = Reverb.BundledCheckout || {};

Reverb.BundledCheckout.CreditCard = (function () {
  var showNewCardFormDataAttr = 'show-credit-card-form-on-change';
  var showNewCardFormSelector = '[data-' + showNewCardFormDataAttr + ']';
  var cardRadioButtonsSelector = showNewCardFormSelector + ' :radio';

  function init() {
    bindAddNewCreditCardChanged();
  }

  function bindAddNewCreditCardChanged() {
    $(document).on('change', cardRadioButtonsSelector, toggleAddCreditCardForm);
  }

  function toggleAddCreditCardForm(e) {
    var $slideoutEl = $($(e.target).closest(showNewCardFormSelector).data(showNewCardFormDataAttr));
    if (newCreditCardSelected()) {
      $slideoutEl.show();
    } else {
      $slideoutEl.hide();
    }
  }

  function newCreditCardSelected() {
    var $selectedButton = $(cardRadioButtonsSelector + ':checked');
    return $.trim($selectedButton.val()) === '';
  }

  return {
    init: init
  };
})();

$(Reverb.BundledCheckout.CreditCard.init);



// WEBPACK FOOTER //
// ./javascripts/components/legacy/bundled_checkout/credit_card.js